export default "__VITE_PUBLIC_ASSET__4494d7bf__"